import { initializeApollo } from '@apollo-client';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import { GET_JOBS } from '@graphql/SelectAllJobsMarketing';
import { JobOpeningsPage } from '@_pages/engineering/job-openings/components';
import type { SelectAllJobsMarketingQuery } from '@_pages/engineering/job-openings/data';
import {
  demystifyJobOpeningsRouteRaw,
  serializerForMarketingJobs,
} from '@_pages/engineering/job-openings/utils';

export async function getServerSideProps({ query, locale }) {
  const apolloClient = initializeApollo();

  // TODO: if error, send error response
  const { data, error } = await apolloClient.query<SelectAllJobsMarketingQuery>({
    query: GET_JOBS,
    context: { clientName: 'hasura' },
    fetchPolicy: 'no-cache',
    // @ts-ignore TODO: should remove?  TODO: fix apollo types
    nextFetchPolicy: 'no-cache',
  });

  if (error) {
    throw new Error(`Error fetching GET_JOBS: ${error}`);
  }

  const marketingJobs = serializerForMarketingJobs(data);

  const { skills, slugs } = query;

  const { jobID } = demystifyJobOpeningsRouteRaw({
    skills,
    slugs,
    supportedRoles: marketingJobs.supportedRoles,
  });

  // We should find a job and all route based filter should be null
  if (jobID != null) {
    const foundJob = data?.icims_job.find((job) => `${job.profile_id}` === jobID);

    if (!foundJob) {
      return {
        notFound: true,
      };
    }
  }

  return {
    props: {
      allJobsData: data,
      marketingJobs,
      ...(await serverSideTranslations(locale)),
    },
  };
}

export default JobOpeningsPage;
